<script setup lang="ts">
import { useTheme } from '../../composables/useTheme'

const { isDark, toggle } = useTheme()
</script>

<template>
  <button
    class="toggle"
    :aria-pressed="isDark"
    :aria-label="isDark ? 'Switch to light theme' : 'Switch to dark theme'"
    @click="toggle"
  >
    <svg v-if="isDark" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7">
      <circle cx="12" cy="12" r="4" />
      <path
        d="M12 3v2m0 14v2m9-9h-2M5 12H3m14.36 6.36l-1.42-1.42M8.05 8.05L6.64 6.64m0 10.72l1.41-1.41M16.95 8.05l1.41-1.41"
        stroke-linecap="round"
      />
    </svg>
    <svg v-else viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7">
      <path d="M21 12.8A9 9 0 1111.2 3a7 7 0 009.8 9.8z" stroke-linecap="round" />
    </svg>
  </button>
</template>

<style scoped>
.toggle {
  width: 2.2rem;
  height: 2.2rem;
  display: grid;
  place-items: center;
  border: 1px solid var(--c-rule);
  border-radius: 50%;
  background: none;
  color: var(--c-ink-2);
  cursor: pointer;
  transition: color 0.2s ease, border-color 0.2s ease, rotate 0.4s var(--ease-out-quint);
}
.toggle:hover {
  color: var(--c-accent);
  border-color: var(--c-accent);
  rotate: 25deg;
}
.toggle svg {
  width: 1rem;
  height: 1rem;
}
</style>
